import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  variant?: 'transparent' | 'solid' | 'mobile';
}

export default function LanguageSwitcher({ variant = 'solid' }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('de') ? 'de' : 'en';

  const handleChange = (lng: string) => {
    i18n.changeLanguage(lng);
    if (typeof document !== 'undefined') {
      document.documentElement.lang = lng;
    }
  };

  const isTransparent = variant === 'transparent';

  const base = 'rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide transition-colors duration-200';

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full p-1 ${
        isTransparent ? 'bg-background-50/10 ring-1 ring-inset ring-background-50/25' : 'bg-background-100 ring-1 ring-inset ring-background-200'
      }`}
    >
      {['de', 'en'].map((lng) => {
        const active = current === lng;
        return (
          <button
            key={lng}
            type="button"
            onClick={() => handleChange(lng)}
            aria-label={lng === 'de' ? 'Deutsch' : 'English'}
            className={`${base} ${
              active
                ? 'bg-primary-500 text-background-50'
                : isTransparent
                  ? 'text-background-100 hover:text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
            }`}
          >
            {lng}
          </button>
        );
      })}
    </div>
  );
}